import type { SettingsNavigationCustomisationInput } from '@atlassian/jira-relay/src/__generated__/updateNavigationCustomisationMutation.graphql';
import type { DisplaySettingsProperties } from './types.tsx';

export const mapProperties = (
	properties: DisplaySettingsProperties,
): SettingsNavigationCustomisationInput['properties'] => {
	return Object.entries(properties).map(([key, value]) => ({ key, value }));
};
